import React from "react";
import {Container} from "react-bootstrap";
import "animate.css";
import contentData from "../data.json";
import Footer from "./Footer2";
import ContentWrapper from "./ContentWrapper";
import LogosWrapper from "./LogosWrapper";

const Content: React.FC = () => {
    return (
        <Container fluid className="content">
            {Object.keys(contentData).map((key, index) => {
                const contentKey = key as keyof typeof contentData;
                const currentContent = contentData[contentKey];

                return (
                    <ContentWrapper key={index} contentKey={contentKey} currentContent={currentContent} />
                );
            })}
            <div id="marcas" className="sticky-section-logos">
            <LogosWrapper/>
            </div>
            <Footer/>
        </Container>
    );
};

export default Content;
